export const features = {
  ToolManagementBasic: 'toolmanagement-basic',
  WebCatalog: 'webcatalog',
  iMMCM: 'iMMCM',
};
